import React, { useState, useRef, useEffect, useMemo } from 'react';
import PostsService from '../../services/PostsService';

const PollContent = ({ poll, postId, currentUser, onVote }) => {
  const [pollState, setPollState] = useState(poll);
  const [userVote, setUserVote] = useState(null);
  const isVotingRef = useRef(false);

  useEffect(() => {
    if (!isVotingRef.current) {
      setPollState(poll);
      // Find the option where current_user_voted is true
      const votedOption = poll.options.find(opt => opt.current_user_voted);
      setUserVote(votedOption ? votedOption.id : null);
    }
  }, [poll]);

  // Calculate total votes
  const totalVotes = useMemo(() => {
    return pollState.options.reduce((sum, option) => sum + (option.vote_count || 0), 0);
  }, [pollState]);

  if (!pollState) return null;


  const handleVote = async (optionId, action = "vote") => {
    if (action === "vote" && userVote) return; // Prevent multiple votes
    isVotingRef.current = true;
    try {
      const response = await PostsService.voteOnPoll(postId, optionId, action);
      const apiOptions = response?.data?.data?.options || [];
      setPollState(prev => ({ ...prev, options: apiOptions.map(opt => ({
        ...opt,
        vote_count: Number(opt.vote_count) || 0
      })) }));
      setUserVote(action === "vote" ? optionId : null);
      if (onVote) await onVote(postId, apiOptions);
    } catch (e) {
      // Optionally show error
    }
    isVotingRef.current = false;
  };

  return (
    <div className="poll-container">
      <h3 className="poll-question">{pollState.question}</h3>
      <div className="poll-options">
        {pollState.options.map(option => {
          const percentage = totalVotes > 0 ? (option.vote_count / totalVotes) * 100 : 0;
          const isSelected = userVote === option.id;
          return (
            <button
              key={option.id}
              className={`poll-option ${isSelected ? 'selected' : ''}`}
              onClick={() => handleVote(option.id, "vote")}
              disabled={!!userVote && !isSelected}
            >
              <div className="poll-option-content">
                <span className="poll-option-text">{option.option_text}</span>
                {(userVote || option.vote_count > 0) && (
                  <span className="poll-option-percentage">
                    {Math.round(percentage)}%
                  </span>
                )}
              </div>
              {(userVote || option.vote_count > 0) && (
                <div
                  className="poll-option-progress"
                  style={{ width: `${percentage}%` }}
                />
              )}
            </button>
          );
        })}
      </div>
      <div className="poll-footer">
        <div className="poll-total-votes">
          {totalVotes} {totalVotes === 1 ? 'vote' : 'votes'}
        </div>
        {userVote && (
          <button 
            className="clear-vote-button" 
            onClick={() => handleVote(userVote, "unvote")}
          >
            Remove vote
          </button>
        )}
      </div>
    </div>
  );
};

export default PollContent;